import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { PageLoaderService } from '@hub/services/PageLoader';
import { Subscription } from "rxjs";

@Directive({
    selector: '[fullPageLoader]'
})
export class FullPageLoaderDirective implements OnDestroy {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private pageLoaderService: PageLoaderService
    ) {
        this.sub = this.pageLoaderService.PageLoading.subscribe((isLoading: boolean) => {
            if (isLoading) {
                this.renderer.addClass(this.el.nativeElement, 'full-page-loader');
            }
            else {
                this.renderer.removeClass(this.el.nativeElement, 'full-page-loader');
            }
        });
    }

    private sub: Subscription;

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
